var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-calendar-check")]), _vm._v(" Aprovar Ata ")], 1)]), _c('div', {
    staticClass: "container dialog pa-5"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Atenção!"), _c('br'), _vm._v(" Ao aprovar a Ata, você confirma todas as informações registradas pelo formador "), _c('strong', [_vm._v(_vm._s(_vm.content.solicitante))]), _vm._v(" sobre a Formação "), _c('strong', [_vm._v(_vm._s(_vm.content.nome))]), _vm._v(". ")])], 1)])], 1), _c('v-row', {
    staticClass: "d-flex align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('span', [_vm._v("Quantidade de participantes presentes*:")])]), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.participantesPresentes,
      callback: function ($$v) {
        _vm.$set(_vm.content, "participantesPresentes", $$v);
      },
      expression: "content.participantesPresentes"
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.content.anexos,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.tamanho`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.getFileSize(item.tamanho)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "small": "",
            "text": "Realizar Download",
            "icon": "mdi-arrow-down"
          },
          on: {
            "click": function ($event) {
              return _vm.baixarArquivo(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.confirmarAta(true);
      }
    }
  }, [_vm._v("Aprovar Ata")]), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.confirmarAta(false);
      }
    }
  }, [_vm._v("Reprovar Ata")]), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.fecharDialog
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }